import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-gray-400 whitespace-nowrap" }
const _hoisted_2 = { class: "leading-5 text-gray-200 truncate" }


export default /*#__PURE__*/_defineComponent({
  __name: 'SummaryRow',
  props: {
  alignStart: Boolean,

  title: {
    type: String,
    required: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex justify-between text-sm gap-4", [__props.alignStart ? 'items-start' : 'items-center']])
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.title), 1),
    _createElementVNode("span", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 2))
}
}

})